import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      textTransform: "none",
      fontFamily: "'Montserrat', sans-serif",
      "& .MuiButton-label": {
        fontFamily: "'Montserrat', sans-serif",
      },
    },
  })
);
